import { render, staticRenderFns } from "./TabularChunkedView.vue?vue&type=template&id=4cb94f73&scoped=true"
import script from "./TabularChunkedView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabularChunkedView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TabularChunkedView.vue?vue&type=style&index=0&id=4cb94f73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb94f73",
  null
  
)

export default component.exports